/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
import { navigatorOnlineCallback } from '../../navigatorOnlineCallback';
import User from '../../currentUser';
import validateJWT from '../../validateJWT';
import cookie from '../../cookie';
import refetchTokens from '../../refetchTokens';

import userSubscriptionQuery from './userSubscriptionQuery';
// eslint-disable-next-line import/no-cycle
import { initTimeOutDSOsChecker } from './syncStuckDSOs';

const user = new User();

let clientRef = null;

let subscribeAttempt = 1;

export const subscriptionFailCallback = subscriptionCallback => async error => {
  if (!navigator.onLine) {
    navigatorOnlineCallback('subscriptionFailCallback', () => {
      console.log('online now, subscriptionFailCallback now!');
      subscriptionFailCallback(subscriptionCallback)(error);
    });
    return;
  }

  if (subscribeAttempt > 2) {
    const lyearnToken = cookie.get('lyearn_token');
    const isValid = validateJWT(lyearnToken);
    if (!isValid) {
      await refetchTokens();
    }
    console.error('failed to eshtablish subscription init in 3 attempts', error);
    window.analytics &&
      window.analytics.track(
        'APPSYNC_SUBSCRIPTION_ERROR',
        {
          errorMessage: error.errorMessage,
          error: JSON.stringify(error),
          cookies: document.cookie,
          type: 'FAILED_TO_ESTABLISH_SUBSCRIPTION',
          url: window.location.href
        },
        3
      );
    setTimeout(() => {
      subscribeAttempt = 1;
      subscriptionFailCallback(subscriptionCallback)('manual');
    }, 30000); // After subscription failure after 3 tries, try again after 30 seconds.
    return;
  }

  subscribeAttempt += 1;
  setTimeout(() => subscribe(subscriptionCallback), 1000);
  console.error('error in subscription', error);
};

function subscribeWhenOnline(subscriptionCallback) {
  navigatorOnlineCallback('backgroundSyncAndRepair', () => {
    console.log('online now, subscribe now!');
    clientRef = subscribe(subscriptionCallback);
    return clientRef;
  });
}

function subscribe(subscriptionCallback) {
  if (!navigator.onLine) {
    console.log('offline now, waiting for subscribe');
    subscribeWhenOnline(subscriptionCallback);
    return null;
  }
  const client = window.appSyncClient;
  const userId = user.id();
  initTimeOutDSOsChecker();
  return client
    .subscribe({ query: userSubscriptionQuery(userId) })
    .subscribe(subscriptionCallback, subscriptionFailCallback(subscriptionCallback));
}

export const initBgSyncService = subscriptionCallback => {
  clientRef = subscribe(subscriptionCallback);
  return clientRef;
};
